module.exports = __webpack_public_path__ + "static/media/orlen-square-r2Za55EsiveoD3Geu2LXyPCAN93v0p.61e14511.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orlen-square-r2Za55EsiveoD3Geu2LXyPCAN93v0p.webp
// module id = 644
// module chunks = 0